export enum IconType {
  RECOMMEND = 'RECOMMEND',
  HISTORY = 'HISTORY',
}
